<script>
import { connect } from 'vuex-connect';
import GameSearchBox from '../scenes/GameSearchBox.vue';

export default connect({
  gettersToProps: {
    games: 'searchedGames',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.filteredGames,
    searchEnabled: state => state.launcher.isSearchEnabled,
  },
  lifecycle: {
    created ({ dispatch, commit }) {
      dispatch('flushSearchedGames');
      commit('disableSearch');
    },
  },
})('GameSearchBox', GameSearchBox);
</script>
